import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const CustomerContext = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const inAdmin = useLocation().pathname.startsWith("/admin");
  const load = () => api.get("/customer/me").then((r) => setCustomer(r.data))
    .catch(() => api.post("/customer/refresh").then(() => api.get("/customer/me")).then((r) => setCustomer(r.data)).catch(() => setCustomer((c) => (c === null ? false : c))));
  useEffect(() => { if (!inAdmin && customer === null) load(); }, [inAdmin, customer]);
  const login = async (email, password) => { const { data } = await api.post("/customer/login", { email, password }); setCustomer(data); return data; };
  const register = async (body) => { const { data } = await api.post("/customer/register", body); setCustomer(data); return data; };
  const logout = async () => { await api.post("/customer/logout").catch(() => {}); setCustomer(false); };
  return <CustomerContext.Provider value={{ customer, setCustomer, login, register, logout }}>{children}</CustomerContext.Provider>;
};

export const useCustomer = () => useContext(CustomerContext);

export const STATUS_LABEL = {
  in_attesa_pagamento: "In attesa di pagamento", pagato: "Pagato", in_preparazione: "In preparazione", spedito: "Spedito",
  consegnato: "Consegnato", annullato: "Annullato", rimborsato: "Rimborsato",
};
